import {requirePermission} from '@/modules/auth/permissions'
import {WardForm} from '@/modules/wards/components/ward-form/ward-form'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const EditWardPageSchema = z.object({
  wardId: z.string().optional(),
})

export const Route = createFileRoute('/configuration/wards/new')({
  beforeLoad: requirePermission('organisation.manage'),
  component: NewWardContainer,
  validateSearch: EditWardPageSchema,
})

function NewWardContainer() {
  const {t} = useTranslate('wards')

  const {wardId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={wardId ? t('edit_ward_title') : t('new_ward_title')}
        description={t('new_ward_description')}
      />

      <WardForm wardId={wardId} />
    </NewResourceFormContainer>
  )
}
